import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from "react-select";
import { ApiCalling } from '../../../Services/Pool';
import { toast } from 'react-toastify'
import { showToastError } from '../../../Utilities/ToastUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import ReuseCode from './ReuseComponent/ReuseCode';
import headerImage from "../../../Assets/headerimage.png";
import familygLogo from "../../../Assets/familylogo.png";
import Back from "../../../Assets/back.png";
import useGetLabels from '../../CustomHookes/useGetLabels';

const Register = () => {
    const navigate = useNavigate()
    const location = useLocation()

    // state for language change
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("language"));

    const handleLanguageChange = (language) => {
        setSelectedLanguage(language);
    };

    const [fullName, setFullName] = useState("");
    const [gender, setGender] = useState(null);
    const [email, setEmail] = useState("");
    const [dob, setDob] = useState();
    const [mobile, setMobile] = useState(location.state?.payload.mobile);
    const [whatsAppNo, setWhatsAppNo] = useState("");
    const [profession, setProfession] = useState("");
    const [employmentStatus, setEmploymentStatus] = useState(null);
    // const [payload] = useState(route.params?.payload)
    const [payload] = useState()

    const genderData = [
        {
            label: selectedLanguage == 'EN' ? "Select Gender" : selectedLanguage == 'MR' ? 'लिंग निवडा' : 'लिंग चुनें',
            value: null,
        },
        {
            label: selectedLanguage == 'EN' ? "Female" : selectedLanguage == 'MR' ? 'स्त्री' : 'महिला',
            value: "Female",
        },
        {
            label: selectedLanguage == 'EN' ? "Male" : selectedLanguage == 'MR' ? 'पुरुष' : 'पुरुष',
            value: "Male",
        },
        {
            label: selectedLanguage == 'EN' ? "Other" : selectedLanguage == 'MR' ? 'इतर' : 'अन्य',
            value: "Other",
        },
    ]

    const employmentStatusData = [
        { value: null, label: selectedLanguage == 'en' ? "Select Employment Status" : selectedLanguage == 'mr' ? 'रोजगार स्थिती निवडा' : 'रोजगार स्थिति का चयन करें', },
        { value: "Self Employed", label: "Self Employed" },
        { value: "Salaried", label: "Salaried" },
        { value: "Business Owner", label: "Business Owner" },
        { value: "Other", label: "Other" },
        { value: "Home Maker", label: "Home Maker" },
        { value: "Social Worker", label: "Social Worker" }
    ]

    const educationData = [
        { value: null, label: selectedLanguage == 'en' ? "Select Education" : selectedLanguage == 'mr' ? 'शिक्षण निवडा' : 'शिक्षा का चयन करें', },
        { value: "SSC", label: "SSC" },
        { value: "HSC", label: "HSC" },
        { value: "Graduate", label: "Graduate" },
        { value: "Other", label: "Other" },
        { value: "Diploma", label: "Diploma" },
        { value: "Post Graduate", label: "Post Graduate" },
        { value: "Doctorate", label: "Doctorate" },
    ]

    const [education, setEducation] = useState(null)
    const [address, setAddress] = useState("")
    const [village, setVillage] = useState("")
    const [district, setDistrict] = useState(null)
    const [taluka, setTaluka] = useState(null)
    const [pincode, setpincode] = useState("")
    const [profilePic, setProfilePic] = useState("")
    const [districtAndTalukaData, setdistrictAndTalukaData] = useState([])



    // for call custom hook
    const { getAllLabels } = useGetLabels();

    let ensetProfileScreenLabels, hnsetProfileScreenLabels, mrsetProfileScreenLabels;

    if (getAllLabels && getAllLabels.length > 0) {
        const labels = getAllLabels[0][selectedLanguage?.toLowerCase()];
        if (labels) {
            ensetProfileScreenLabels = labels.setProfileScreen;
            hnsetProfileScreenLabels = labels.setProfileScreen;
            mrsetProfileScreenLabels = labels.setProfileScreen;
        }
    }


    // District and Taluka Data
    const [districtData, setDistrictData] = useState([{
        label: selectedLanguage == 'en' ? "Select District" : selectedLanguage == 'mr' ? 'जिल्हा निवडा' : 'जिला चुनें',
        value: null,
    }])
    const [talukaData, setTalukaData] = useState([
        {
            label: selectedLanguage == 'en' ? "Select Taluka" : selectedLanguage == 'mr' ? 'तालुका निवडा' : 'तालुका का चयन करें',
            value: null,
        }
    ])


    // Fetching District and talukas
    const getDistrictAndTaluka = async (userData) => {
        const url = ApiCalling.base_url_v1;
        const constant = `/user/getTalukaAndDistrict`;
        const method = "GET";
        const reqBody = {};
        try {

            await fetch(url + constant).then(res => res.json()).then((data) => {
                const res = {
                    status: 200,
                    data
                }
                if (res.status == 200) {
                    res.data && res.data.length > 0 && setdistrictAndTalukaData(res.data)
                    let districtArr = res.data && res.data.length > 0 && res.data.map(item => item.district)
                    districtArr = [... new Set(districtArr)]
                    const districtArrayData = districtArr.map(item => ({
                        label: item,
                        value: item,
                    }));
                    setDistrictData([...districtData, ...districtArrayData]);
                    if (userData && Object.hasOwn(userData, "district")) {
                        setDistrict(userData.district)
                    } else {
                        // null
                    }
                    // userData && Object.hasOwn(userData, "district") ? setDistrict(userData.district) : null;
                }
                else {
                    showToastError("Error while fetchning district and taluka")
                }
            }).catch(err => {
                showToastError("Error while fetching talukas")
                console.warn(err)
            })
        } catch (error) {
            console.error(error)
        }
    }

    // Filter Talukas
    const getTalukas = (district) => {
        let talukaArr = districtAndTalukaData && districtAndTalukaData?.length > 0 &&
            districtAndTalukaData?.filter(item => item.district == district?.label).map(item => item.taluka)
        talukaArr = talukaArr && talukaArr.length > 0 && [... new Set(talukaArr)]
        talukaArr = talukaArr && talukaArr.length > 0 && talukaArr.map(item => {
            return {
                label: item, value: item,
            }
        })
        talukaArr && talukaArr.length > 0 && talukaArr.unshift({
            label: selectedLanguage == 'en' ? "Select Taluka" : selectedLanguage == 'mr' ? 'तालुका निवडा' : 'तालुका का चयन करें',
            value: null,
        })
        talukaArr && talukaArr.length > 0 && setTalukaData(talukaArr);
    }

    // Sets Taluka Data
    useEffect(() => {
        getTalukas(district);
    }, [district])

    useEffect(() => {
        getDistrictAndTaluka()
    }, [])

    // Error State
    const [fullNameErr, setFullNameErr] = useState(false)
    const [genderErr, setGenderErr] = useState(false)
    const [dobErr, setDobErr] = useState(false)
    const [districtErr, setDistrictErr] = useState(false)
    // const [mobileErr, setMobileErr] = useState(false)

    function resetError() {
        setFullNameErr(false)
        setGenderErr(false)
        setDobErr(false)
        setDistrictErr(false)
        // setMobileErr(false)
    }

    const validate = () => {
        let validate = true;

        resetError();

        if (fullName === "") { setFullNameErr(true); validate = false }
        if (gender === "" || gender === "select_gender" || gender === null) { setGenderErr(true); validate = false };
        if (dob === undefined) { setDobErr(true); validate = false }
        if (district === "" || district === null) { setDistrictErr(true); validate = false; }
        // if (mobile === "" || mobile?.length !== 10) { setMobileErr(true); validate = false }

        return validate;
    }



    return (
        <>
            <div style={{ marginBottom: "20%" }}>
                <ReuseCode
                    headerImage={headerImage}
                    Back={Back}
                    familygLogo={familygLogo}
                    title={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.title : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.title : ensetProfileScreenLabels?.title}
                    onLanguageChange={handleLanguageChange}
                />
                <Row className='m-3'>
                    <Col md={6}>
                        {fullNameErr ? <span className='errMsg'>* {selectedLanguage === "mr" ? "कृपया पूर्ण नाव प्रविष्ट करा" : selectedLanguage === "hn" ? "कृपया पूरा नाम दर्ज करें" : "Please Enter full Name"}</span> : null}
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "पूर्ण नाव प्रविष्ट करा" : selectedLanguage === "hn" ? "पूरा नाम दर्ज करें" : "Full Name"} <span className='text-danger'>*</span></Form.Label>
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.fullName : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.fullName : ensetProfileScreenLabels?.fullName} className="custom-placeholder-color inputStyle"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        {genderErr ? <span className='errMsg'>*{selectedLanguage === "mr" ? "कृपया लिंग निवडा" : selectedLanguage === "hn" ? "कृपया लिंग चुनें" : "Please Enter gender"}</span> : null}
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "कृपया लिंग निवडा" : selectedLanguage === "hn" ? "लिंग चुनें" : "Please Enter gender"} <span className='text-danger'>*</span></Form.Label>
                            <Select
                                placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.gender : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.gender : ensetProfileScreenLabels?.gender}
                                isMulti={false}
                                isSearchable={true}
                                value={gender}
                                options={genderData}
                                onChange={(option) => {
                                    setGender(option)
                                }}
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderColor: state.isFocused ? '#f4a28b' : '#f4a28b',
                                        padding: "15px",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            borderColor: '#f4a28b',
                                        },
                                    }),
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "ईमेल प्रविष्ट करा" : selectedLanguage === "hn" ? "ईमेल दर्ज करें" : "Enter Email"}</Form.Label>
                            <Form.Control size='lg' type='email' placeholder={selectedLanguage === "mr" ? "ईमेल आईडी" : selectedLanguage === "hn" ? "ईमेल आईडी" : "Email Id"}
                                className="custom-placeholder-color inputStyle"
                                value={email} onChange={(e) => { setEmail(e.target.value) }} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        {dobErr ? <span className='errMsg'>*{selectedLanguage === "mr" ? "कृपया जन्मतारीख निवडा" : selectedLanguage === "hn" ? "कृपया जन्मतिथि चुनें" : "Please select date of birth"}</span> : null}
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "जन्मतारीख निवडा" : selectedLanguage === "hn" ? "जन्मतिथि चुनें" : "Select Date of Birth"} <span className='text-danger'>*</span></Form.Label>
                            <Form.Control size='lg' type='date' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.dob : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.dob : ensetProfileScreenLabels?.dob} className="custom-placeholder-color inputStyle"
                                value={dob} onChange={(e) => setDob(e.target.value)} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        {/* {mobileErr ? <span className='errMsg'>*Please enter mobile number</span> : null} */}
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "मोबाइल प्रविष्ट करा" : selectedLanguage === "hn" ? "मोबाइल दर्ज करें" : "Enter Mobile"} <span className='text-danger'>*</span></Form.Label>
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.mob : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.mob : ensetProfileScreenLabels?.mob} className="custom-placeholder-color inputStyle"
                                value={mobile} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? " what's app नंबर प्रविष्ट करा" : selectedLanguage === "hn" ? "व्हाट्स ऐप नंबर दर्ज करें" : "Enter What's App Number"}</Form.Label>
                            < Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.WhatAppNo : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.WhatAppNo : ensetProfileScreenLabels?.WhatAppNo} className="custom-placeholder-color inputStyle"
                                value={whatsAppNo} onChange={(e) => { setWhatsAppNo(e.target.value) }} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "व्यवसाय प्रविष्ट करा" : selectedLanguage === "hn" ? "पेशा दर्ज करें" : "Enter Professione"}</Form.Label>
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.profession : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.profession : ensetProfileScreenLabels?.profession} className="custom-placeholder-color inputStyle"
                                value={profession} onChange={(e) => { setProfession(e.target.value) }} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "रोजगाराची स्थिती निवडा" : selectedLanguage === "hn" ? "रोजगार का चयन करें" : "Select Employment Status"}</Form.Label>
                        <Form.Group className="mb-3">
                            <Select
                                isMulti={false}
                                isSearchable={true} size="lg"
                                placeholder={selectedLanguage === "mr" ? "कृपया रोजगार स्थिती निवडा" : selectedLanguage === "hn" ? "रोजगार स्थिति का चयन करें" : "Select Employment Status"}
                                value={employmentStatus}
                                options={employmentStatusData}
                                onChange={(option) => { setEmploymentStatus(option) }}
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderColor: state.isFocused ? '#f4a28b' : '#f4a28b',
                                        padding: "15px",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            borderColor: '#f4a28b',
                                        },
                                    }),
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "शिक्षण निवडा" : selectedLanguage === "hn" ? "शिक्षा का चयन करें" : "Select Education"}</Form.Label>
                        <Form.Group className="mb-3">
                            <Select
                                isMulti={false}
                                isSearchable={true} size="lg"
                                placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.education : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.education : ensetProfileScreenLabels?.education}
                                value={education}
                                options={educationData}
                                onChange={(option) => { setEducation(option) }}
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderColor: state.isFocused ? '#f4a28b' : '#f4a28b',
                                        padding: "15px",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            borderColor: '#f4a28b',
                                        },
                                    }),
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "पत्ता प्रविष्ट करा" : selectedLanguage === "hn" ? "पता दर्ज करें" : "Enter Address"}</Form.Label>
                        <Form.Group className="mb-3">
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.address : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.address : ensetProfileScreenLabels?.address} className="custom-placeholder-color inputStyle"
                                value={address} onChange={(e) => setAddress(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "गाव प्रविष्ट करा" : selectedLanguage === "hn" ? "गांव दर्ज करें" : "Enter village"}</Form.Label>
                        <Form.Group className="mb-3">
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.village : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.village : ensetProfileScreenLabels?.village} className="custom-placeholder-color inputStyle"
                                value={village} onChange={(e) => {
                                    setVillage(e.target.value)
                                }} />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        {districtErr ? <span className='errMsg'>*{selectedLanguage === "mr" ? "कृपया जिल्हा प्रविष्ट करा" : selectedLanguage === "hn" ? "कृपया जिला दर्ज करें" : "Plase enter district"}</span> : null}
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "जिल्हा प्रविष्ट करा" : selectedLanguage === "hn" ? "जिला दर्ज करें" : "Select District"}<span className='text-danger'>*</span></Form.Label>
                        <Form.Group className="mb-3">
                            <Select
                                isMulti={false}
                                isSearchable={true} size="lg"
                                placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.district : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.district : ensetProfileScreenLabels?.district}
                                value={district}
                                options={districtData}
                                onChange={(option) => { setDistrict(option) }}
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderColor: state.isFocused ? '#f4a28b' : '#f4a28b',
                                        padding: "15px",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            borderColor: '#f4a28b',
                                        },
                                    }),
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "तालुका प्रविष्ट करा" : selectedLanguage === "hn" ? "तालुका दर्ज करें" : " Select Taluka"}</Form.Label>
                        <Form.Group className="mb-3">
                            <Select
                                isMulti={false}
                                isSearchable={true} size="lg"
                                placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.taluka : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.taluka : ensetProfileScreenLabels?.taluka}
                                value={taluka}
                                options={talukaData}
                                onChange={(option) => { setTaluka(option) }}
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderColor: state.isFocused ? '#f4a28b' : '#f4a28b',
                                        padding: "15px",
                                        borderRadius: "8px",
                                        '&:hover': {
                                            borderColor: '#f4a28b',
                                        },
                                    }),
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className='fw-bold'>{selectedLanguage === "mr" ? "पिनकोड टाका" : selectedLanguage === "hn" ? "पिनकोड दर्ज करें" : "Enter Pincode"}</Form.Label>
                            <Form.Control size='lg' placeholder={selectedLanguage === "mr" ? mrsetProfileScreenLabels?.pinCode : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.pinCode : ensetProfileScreenLabels?.pinCode} className="custom-placeholder-color inputStyle"
                                value={pincode} onChange={(e) => {
                                    setpincode(e.target.value)
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <div style={{ display: "flex", justifyContent: "space-around", margin: "0px 15px 0px 15px" }}>
                    <Button style={{
                        borderRadius: "20px", padding: "10px", width: "35%", backgroundColor: "transparent", color: "#FD6E47",
                        border: "1px solid #FD6E47"
                    }}
                        onClick={() => navigate("/mobilenumber")}>{selectedLanguage === "mr" ? "मागे" : selectedLanguage === "hn" ? "पीछे" : "Back"}</Button>
                    <Button
                        style={{ borderRadius: "20px", padding: "10px", width: "35%", backgroundColor: "#FD6E47", color: "white", border: "none" }}
                        onClick={() => {
                            if (validate()) {
                                navigate('/setpassword',
                                    {
                                        state: {
                                            payload: {
                                                name: fullName,
                                                gender: gender?.label,
                                                email: email,
                                                dob: dob,
                                                mobile: mobile,
                                                whatsAppNumber: whatsAppNo,
                                                profession: profession,
                                                employmentStatus: employmentStatus?.label,
                                                education: education?.label,
                                                address: address,
                                                village: village,
                                                district: district?.label,
                                                taluka: taluka?.label,
                                                pincode: pincode,
                                                profilePic: profilePic,
                                            }
                                        }
                                    })
                            }
                        }}>
                        {selectedLanguage === "mr" ? mrsetProfileScreenLabels?.submitBtn : selectedLanguage === "hn" ? hnsetProfileScreenLabels?.submitBtn : ensetProfileScreenLabels?.submitBtn}</Button>
                </div>
            </div>
        </>
    )
}

export default Register
